<template>
    <div class="zeroInterest-card ap_zeroInterest mb-3">
        <h3 class="zeroInterest-title">
            <i class="font-icons icons-credit-card"></i>
            Hasta <span class="zeroInterest-installmentsNumber">36</span> <strong>cuotas</strong>
        </h3>
</div>
</template>

<script>




export default {
    data() {
        return {
            data: {}
        };
    },
    async mounted() {
    },
    methods: {

    },
    components: {

    }
}
</script>
